import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TrialDaysResponse } from '../api/trial-api';

export interface TrialState {
  daysRemaining: number;
  trialEnabled: boolean;
  trialEndsAt: string | null;
  isInTrial: boolean;
  loading: boolean;
  error: string | null;
  lastFetched: number | null;
}

const initialState: TrialState = {
  daysRemaining: 0,
  trialEnabled: false,
  trialEndsAt: null,
  isInTrial: false,
  loading: false,
  error: null,
  lastFetched: null,
};

const trialSlice = createSlice({
  name: 'trial',
  initialState,
  reducers: {
    fetchTrialDaysRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchTrialDaysSuccess: (state, action: PayloadAction<TrialDaysResponse>) => {
      state.loading = false;
      state.daysRemaining = action.payload.daysRemaining;
      state.trialEnabled = action.payload.trialEnabled;
      state.trialEndsAt = action.payload.trialEndsAt;
      state.isInTrial = action.payload.isInTrial;
      state.lastFetched = Date.now();
      state.error = null;
    },
    fetchTrialDaysFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearTrialError: (state) => {
      state.error = null;
    },
    resetTrialState: (state) => {
      return initialState;
    },
  },
});

export const {
  fetchTrialDaysRequest,
  fetchTrialDaysSuccess,
  fetchTrialDaysFailure,
  clearTrialError,
  resetTrialState,
} = trialSlice.actions;

export default trialSlice.reducer;



